.columnSelector {
  position: relative;
  display: inline-block;
}

.listWrapper {
  border-radius: 0.75rem;
  border: 1px solid var(--static-divider-standard);
  background: var(--static-background-standard);
  box-shadow: var(--box-shadow);
  overflow-y: auto;
}

.list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: min-content;
  margin: auto;
}

.listItem {
  padding: 0.5rem 1rem 0.5rem 0.75rem;
  white-space: nowrap;
  display: flex;
  min-width: 9rem;
  justify-content: start;
  align-items: center;
  gap: 0.25rem;
  font-size: var(--fs-small);
  cursor: pointer;
}


.listDragHandle {
  width: 1rem;
  height: 1rem;
  cursor: move;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
}

.iconDragContainer {
  color: var(--static-text-standard);
}